module.exports = __webpack_public_path__ + "media/toolkits/COVID-mobile-header-f3744939.jpg";